import React from 'react';

import { faList, faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';

import { useDispatch, useSelector } from './store/hooks';
import { getCurrentView } from './store/selectors/ui';
import { switchViewToList, switchViewToMap } from './store/actions/ui';

import Toggle from 'bundles/research/index/components/toggle';

export default function CompsViewToggle() {
  const currentTab = useSelector(getCurrentView);
  const dispatch = useDispatch();

  return (
    <Toggle
      options={[
        { label: 'Map view', value: 'map', icon: faMapMarkerAlt },
        { label: 'Table view', value: 'list', icon: faList },
      ]}
      value={currentTab}
      onChange={value => dispatch(value === 'map' ? switchViewToMap() : switchViewToList())}
    />
  );
}
